const SOBERANO_PACKAGE_ID = 29;

export const packages = {
    infinity: {
        id: 24,
        key: 'infinity',
        label: 'Infinity',
    },
    premium: {
        id: 23,
        key: 'premium',
        label: 'Premium',
    },
    start: {
        id: 20,
        key: 'start',
        label: 'Start',
    },
    single: {
        id: 25,
        key: 'single',
        label: 'Avulsa',
    },
    soberano: {
        id: SOBERANO_PACKAGE_ID,
        key: 'soberano',
        label: 'Soberano',
        color: '#8C6F2C',
    },
};

export const isSoberanoPackage = (pack) => pack?.id === packages.soberano.id;

export const blocksPurchaseRecurrence = (pack) =>
    !!pack?.blockPurchaseRecurrence || (pack?.purchaseRestrictions || []).includes('purchaseRecurrence');

export const packagesWithInfinityBenefits = [packages.infinity.id, packages.soberano.id];
